module.exports = __webpack_public_path__ + "static/media/awad2.c3b2cdd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/awad2.png
// module id = 1663
// module chunks = 0